<template>
  <!-- 志愿者公益讲解时间表 -->
  <div class="page-volunteer-time norem">
    <div class="header">
      <div class="header-left">
        <img src="~@images/logo.png" alt="" />
      </div>
      <h1>志愿者公益讲解时间表</h1>
      <span class="date">{{ dateTime }}</span>
    </div>

    <div class="content">
      <div class="table">
        <div class="table-h">
          <div class="label">展 览</div>
          <div class="label">时 间</div>
        </div>
        <div class="table-con">
          <div class="item" v-for="(item, i) in dataList" :key="i">
            <div class="label">{{ item.name }}</div>
            <div class="label label_list">
              <!-- {{ item.appointmentTime }} -->
              <span class="tag" v-for="it in item.labels">{{it}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="tips">
        <h2>温馨提示</h2>
        <div class="tips-con">
          <p>
            1、“讲解时间表”内时间是每场讲解的开始时间，志愿者将在展厅入口处组织观众。如志愿者未在此处等候，表示已进馆讲解。请移步展厅内，寻找身穿蓝马甲、胸前佩戴“辽博志愿者工作证”的志愿者。
          </p>
          <p>
            2、辽博志愿者经培训、考核合格后才能为观众提供公益讲解服务，他们免费为观众提供讲解、咨询引导等服务，不收取任何费用。讲解过程中，请不要录音、录像，祝您参观愉快！
          </p>
          <p>
            3、您也可以通过“数字辽博”小程序实时查询辽博志愿者公益讲解时间。请在微信小程序搜索“数字辽博”
            ，进入“数字辽博”小程序后，点击“志愿服务”——“讲解时间表”，就可以查阅辽博志愿者当天以及未来几天的展览讲解时间，您可合理安排自己的参观。
          </p>
          <p>
            赠人玫瑰，手有余香。辽博全体志愿者诚邀您走进辽宁省博物馆，为您讲述中国故事。传播历史，我们一直在努力！
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dateTime: '',
      dataList: []
    }
  },
  methods: {
    getData() {
      this.$http
        .get('../singleMuseum/applet/volunteer/todayExhibition', {})
        .then((res) => {
          if (res.success) {
            let data = res.result
            this.dateTime = data.date
            data.arrList = data.list.filter(item => item.appointmentTime)
            // console.log(111, data.arrList)
            data.arrList.forEach(item => {
              item.labels = item.appointmentTime && item.appointmentTime.split(',')
            })
            this.dataList = data.arrList
          } else {
            this.$message.error(res.message)
          }
        })
    }
  },
  created() {
    // document.title = '志愿者公益讲解时间表'
    this.getData()

    // 开发环境不循环 便于查看控制台
    if (process.env.VUE_APP_START_INTERVAL == '1') {
      if (window.InitSetInterval) {
        clearInterval(window.InitSetInterval)
      }
      window.InitSetInterval = setInterval(() => {
        console.log('refresh')
        this.getData()
      }, 1000 * 5) // 5秒
    }
  },
  beforeDestroy() {
    if (window.InitSetInterval) {
      clearInterval(window.InitSetInterval)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-volunteer-time {
  padding: 30px;
  background: #f2f2f2;
  color: #333;
  box-sizing: border-box;
  min-height: 100vh;
  &.norem {
    font-size: 16px;
    .header {
      padding: 30px;
      box-sizing: border-box;
      width: 100%;
      background: #fff;
      display: flex;
      align-items: center;
      height: 80px;
      img {
        width: 180px;
      }
      h1 {
        font-size: 28px;
        flex: 1;
        text-align: center;
        color: #306159;
      }
    }
    .content {
      margin-top: 20px;
      .table {
        width: 100%;
        background: #fff;
        .table-h,
        .item {
          display: flex;
          .label {
            border-bottom: solid 1px rgba(0, 0, 0, 0.1);
            line-height: 50px;
            text-align: center;
            &:nth-child(1) {
              width: 30%;
            }
            &:nth-child(2) {
              width: 70%;
              border-left: solid 1px rgba(0, 0, 0, 0.1);
            }
          }
          &:last-child {
            .label {
              border-bottom: none;
            }
          }
        }
        .table-h {
          background: #fafafa;
          color: rgba(0, 0, 0, 1);
        }
      }
      .table-con {
        .label_list {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          padding-bottom: 10px;
          .tag {
            margin-right: 10px;
            margin-top: 10px;
            border: solid 1px #ccc;
            background: #ececec;
            padding: 2px 5px;
            height: 30px;
            line-height: 30px;
            border-radius: 8px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }

      .tips {
        margin-top: 20px;
        padding: 20px;
        background: #fff;
        h2 {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        p {
          margin-bottom: 20px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
